import type { StylableElementProps } from '@subaio/components'
import { getCountry } from '@subaio/utils'

import { CountryFlagSquare } from '../../CountryFlag'

type Props = StylableElementProps & {
	brandId?: string
	size?: number
	defaultImage?: string
}

export const BrandFlag = ({ brandId, size = 28, defaultImage, className, style }: Props) => (
	<CountryFlagSquare
		countryCode={getCountry(brandId ?? '')}
		defaultImage={defaultImage}
		size={size}
		className={className}
		style={style}
	/>
)
